import type { IconNode } from '../types';

/**
 * @name mail-pen
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUuNTA2IDE3LjY0NkEyIDIgMCAwMDE1IDE4LjVsLS44MzcgMi44N2EuNS41IDAgMDAuNjIuNjJsMi44Ny0uODM3YTIgMiAwIDAwLjg1NC0uNTA2bDMuMDEzLTMuMDA5YTEgMSAwIDAwLTMuMDA0LTMuMDA0eiIgLz4KICA8cGF0aCBkPSJNMjIgMTAuMzQ2VjZhMiAyIDAgMDAtMi0ySDRhMiAyIDAgMDAtMiAydjEyYTIgMiAwIDAwMiAyaDYuMzk2IiAvPgogIDxwYXRoIGQ9Im0yMiA3LTguOTkxIDUuNzI3YTIgMiAwIDAxLTIuMDA5IDBMMiA3IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/mail-pen
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const MailPen: IconNode = [
  [
    'path',
    {
      d: 'M15.506 17.646A2 2 0 0015 18.5l-.837 2.87a.5.5 0 00.62.62l2.87-.837a2 2 0 00.854-.506l3.013-3.009a1 1 0 00-3.004-3.004z',
    },
  ],
  ['path', { d: 'M22 10.346V6a2 2 0 00-2-2H4a2 2 0 00-2 2v12a2 2 0 002 2h6.396' }],
  ['path', { d: 'm22 7-8.991 5.727a2 2 0 01-2.009 0L2 7' }],
];

export default MailPen;
